export default "__VITE_ASSET__B6TK$icc__"